import styled, { CSSProperties } from 'styled-components';

import { borders, breakpoints, sizes } from '../../theme';

export interface ImageProps {
  width?: string;
  height?: string;
  mobWidth?: string;
  mobHeight?: string;
  margin?: {
    top?: string;
    right?: string;
    bottom?: string;
    left?: string;
  };
  size?: string;
  borderRadiusType?: 'rounded' | 'circle';
  cursor?: 'pointer' | 'default';
  border?: string;
  maxWidth?: string;
  maxHeight?: string;
  objectFit?: CSSProperties['objectFit'];
}

// Because size prop is optional we need to check if it is there
// because 'undefined' cannot be used as index.
// Order of precedence for props: size > width > <hard-coded-value>
export const Image = styled.img<ImageProps>`
  width: ${({ size, width }) => (size ? sizes[size].width : width || undefined)};
  height: ${({ size, height }) => (size ? sizes[size].height : height || undefined)};
  max-width: ${({ maxWidth }) => maxWidth ?? 'unset'};
  max-height: ${({ maxHeight }) => maxHeight ?? 'unset'};
  cursor: ${({ cursor }) => cursor || 'default'};
  border-radius: ${({ borderRadiusType }) =>
    borderRadiusType ? borders[borderRadiusType] : undefined};
  margin-top: ${({ margin }) => margin?.top || undefined};
  margin-right: ${({ margin }) => margin?.right || undefined};
  margin-bottom: ${({ margin }) => margin?.bottom || undefined};
  margin-left: ${({ margin }) => margin?.left || undefined};
  object-fit: ${({ objectFit }) => objectFit || 'cover'};
  @media (${breakpoints.md}) {
    width: ${({ size, mobWidth }) => (size ? sizes[size].mobWidth : mobWidth || '100px')};
    height: ${({ size, mobHeight }) => (size ? sizes[size].mobHeight : mobHeight || '100px')};
  }
`;

export const ImageResponsive = styled.img<ImageProps>`
  box-sizing: border-box;
  width: ${({ size, width }) => (size ? sizes[size].width : width || undefined)};
  height: ${({ size, height }) => (size ? sizes[size].height : height || undefined)};
  cursor: ${({ cursor }) => cursor || 'default'};
  border: ${({ border }) => border ?? 'unset'};
  border-radius: ${({ borderRadiusType }) =>
    borderRadiusType ? borders[borderRadiusType] : undefined};
  margin-top: ${({ margin }) => margin?.top || undefined};
  margin-right: ${({ margin }) => margin?.right || undefined};
  margin-bottom: ${({ margin }) => margin?.bottom || undefined};
  margin-left: ${({ margin }) => margin?.left || undefined};
  object-fit: cover;
  object-position: center;
`;
